import { legacy_createStore, applyMiddleware } from 'redux'
import createSagaMiddleware from 'redux-saga';
import rootSaga from '../sagas/index';
import rootReducer from '../reducers/index';
import { albumBuilderHistoryMiddleware } from '@/engine/album/utils/historyMiddleware';

const sagaMiddleware = createSagaMiddleware();

const store = legacy_createStore(rootReducer as any, applyMiddleware(albumBuilderHistoryMiddleware, sagaMiddleware));

sagaMiddleware.run(rootSaga);

(window as any).__PSP_STORE__ = store;

export default store;